var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"create-user"},[(_vm.menus.length > 1)?_c('div',{staticClass:"create-user__buttons"},_vm._l((_vm.menus),function(menu,id){return _c('router-link',{key:id,staticClass:"create-user__button-router",attrs:{"to":menu.to}},[_vm._v(_vm._s(menu.tag))])}),1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }